import { ITypeOffer, TypeOffer } from './../../../../../models/typeOffer.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Validation } from '../../../error/error-messages/validator-messages';
import { Router } from '@angular/router';
import { IPromotionItem } from '../../../../../models/promotionItem.model';
import { Location } from '@angular/common';
import { TypeOfferService } from '../../../../../services/typeOffer.service';
import { NameValidator } from '../../../validators/name.validator';

@Component({
  selector: 'app-offer-type',
  templateUrl: './offer-type.component.html',
  styleUrls: ['./offer-type.component.scss']
})
export class OfferTypeComponent implements OnInit {

  // @ts-ignore
  offertypes: ITypeOffer[] = [];
  offertypeitems : IPromotionItem[] = [];
  // @ts-ignore
  currentoffertype: IPromotion = [];
  search: any;
  page = 1;
  perPage = 10;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  isTrueName = false;
  x_article_achete_y_article_offert = false;
  x_pourcent_de_reduction_produit  = false;
  x_pourcent_de_reduction_service  = false;
  livraison_gratuite = false;
  frais_de_deplacement_gratuite = false;
  reduction_de_x_montant_sur_les_frais_de_deplacement = false;
  livraison_gratuite_x_montant = false;
  x_montant_reduit_sur_la_livraison_des_articles = false;
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
  x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
  x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
  @ViewChild('closebutton') closebutton;
  slugArray:any=["livraison-gratuite", "x-pourcent-de-reduction-produit" ,"x-pourcent-de-reduction-service", "livraison-gratuite-a-partir-dun-x-montant-dachat",
                 "x-montant-reduit-sur-la-livraison-des-articles", "x-article-achete-y-article-offert",
                 "x-produit-achete-n-ieme-a-y-pourcent-de-reduction", "x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction",
                 "x-produit-achete-le-reste-a-y-pourcent-de-reduction", "frais-de-deplacement-gratuit","reduction-de-x-montant-sur-les-frais-de-deplacement"];
  constructor(private fb: FormBuilder ,
              private router :Router, private formB : FormBuilder,
              private typeOfferService: TypeOfferService, private location: Location) { }

  ngOnInit(): void {
    this.loadOfferTypes();
  }

  typeOfferForm = this.fb.group({
    typeOfferForm0: this.fb.group({
      name : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
      slug : new FormControl ("" , [Validators.required]),
      type : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    // x-pourcent-de-reduction
    typeOfferForm1: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    // Livraison-gratuite-x-montant
    typeOfferForm2: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    // x-montant-reduit-sur-la-livraison-des-articles
    typeOfferForm3: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    // x-article-achete-y-article-offert
    typeOfferForm4: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    // x-produit-achete-n-ieme-a-y-pourcent-de-reduction ||
    typeOfferForm5: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
      param2 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyLetterValidator, Validators.minLength(2), Validators.maxLength(100)]),
    }),

    typeOfferForm6: this.fb.group({
      description : new FormControl("" , [Validators.required, Validators.minLength(10)]),
    }),
  });

  get testName() {return this.typeOfferForm.get('typeOfferForm0.name');}
  get testSlug() {return this.typeOfferForm.get('typeOfferForm0.slug');}
  get testType() {return this.typeOfferForm.get('typeOfferForm0.type');}

  // x-pourcent-de-reduction
  get testParam1() {return this.typeOfferForm.get('typeOfferForm1.param0');}
  // Livraison-gratuite-x-montant
  get testParam02() {return this.typeOfferForm.get('typeOfferForm2.param0');}
  // x-montant-reduit-sur-la-livraison-des-articles
  get testParam03() {return this.typeOfferForm.get('typeOfferForm3.param0');}
  // x-article-achete-y-article-offert
  get testParam0100() {return this.typeOfferForm.get('typeOfferForm4.param0');}
  get testParam041() {return this.typeOfferForm.get('typeOfferForm4.param1');}
  // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
  get testParam050() {return this.typeOfferForm.get('typeOfferForm4.param0');}
  get testParam051() {return this.typeOfferForm.get('typeOfferForm4.param1');}
  get testParam052() {return this.typeOfferForm.get('typeOfferForm4.param2');}


  get testParam6() {return this.typeOfferForm.get('typeOfferForm6.description');}


  model = {
    description: ''
  };

  currentOffer: TypeOffer;
  onViewOfferType(offer: any) {
    this.typeOfferService.getIdTypeOffer(offer.id).subscribe(offerType =>  {
      this.currentOffer = offerType;
      //console.log("Détails Offer.....");
      //console.log(this.currentOffer);
    });
  }

  getSelectedSlug(val: any){
    let index = val;
    //console.log(index);
    if(index === "livraison-gratuite"){
      this.livraison_gratuite = true;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-pourcent-de-reduction-produit"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = true;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "livraison-gratuite-a-partir-dun-x-montant-dachat"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = true;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-montant-reduit-sur-la-livraison-des-articles"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = true;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-produit-achete-n-ieme-a-y-pourcent-de-reduction"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = true;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-article-achete-y-article-offert"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = true;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "frais-de-deplacement-gratuit"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = true;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "reduction-de-x-montant-sur-les-frais-de-deplacement"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = true;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-pourcent-de-reduction-service"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = true;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = true;
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
    }else if(index === "x-produit-achete-le-reste-a-y-pourcent-de-reduction"){
      this.livraison_gratuite = false;
      this.x_article_achete_y_article_offert = false;
      this.x_pourcent_de_reduction_produit  = false;
      this.x_pourcent_de_reduction_service = false;
      this.livraison_gratuite_x_montant = false;
      this.x_montant_reduit_sur_la_livraison_des_articles = false;
      this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
      this.frais_de_deplacement_gratuite = false;
      this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
      this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false
      this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = true;
    }

  }

  loadOfferTypes(){
    this.typeOfferService.getTypeOffers().subscribe(rs=>{
      this.offertypes = rs;
      //console.log(this.offertypes)
    });
  }

  getOfferTypeByInputSlug(){

  }

  goBack(): void {
    this.location.back();
  }

  onOfferTypeFormSubmit(){
    if(this.typeOfferForm.controls.typeOfferForm0.invalid){
      this.typeOfferForm.controls.typeOfferForm0.markAllAsTouched();
      this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
      return;
    }
    if(this.typeOfferForm.controls.typeOfferForm0.valid &&
       this.typeOfferForm.controls.typeOfferForm6.valid &&
       this.livraison_gratuite){
      // livraison gratuite
      let typeOffer = new TypeOffer();
      let form = this.typeOfferForm.controls['typeOfferForm0'].value;
      let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
      typeOffer.name = form.name;
      typeOffer.slug = form.slug;
      typeOffer.type = form.type;
      typeOffer.description = formd.description;
     // console.log("Nouveau type d\'offre à enregistrer avec livraison gratuite...");
      //console.log(typeOffer);
      this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Le type d\'offre a été ajouté avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadOfferTypes();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 2500
        });
      });
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.x_pourcent_de_reduction_produit || this.x_pourcent_de_reduction_service){
      if(this.typeOfferForm.controls.typeOfferForm1.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x-pourcent-de-reduction
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm1'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        let typeOffer = new TypeOffer();
        typeOffer.name = form.name;
        typeOffer.slug = form.slug;
        typeOffer.type = form.type;
        typeOffer.param0 = form1.param0;
        typeOffer.description = formd.description;
       // console.log("Nouveau type d'offre à enregistrer avec x-pourcent-de-reduction...");
       // console.log(typeOffer);
        this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été ajouté avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
          //console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }

    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.livraison_gratuite_x_montant){
      if(this.typeOfferForm.controls.typeOfferForm2.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // livraison_gratuite_x_montant
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm2'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        let typeOffer = new TypeOffer();
        typeOffer.name = form.name;
        typeOffer.slug = form.slug;
        typeOffer.type = form.type;
        typeOffer.param0 = form1.param0;
        typeOffer.description = formd.description;
        //console.log("Nouveau type d'offre à enregistrer avec livraison_gratuite_x_montant...");
       // console.log(typeOffer);
        this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été ajouté avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.x_montant_reduit_sur_la_livraison_des_articles){
      if(this.typeOfferForm.controls.typeOfferForm3.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_montant_reduit_sur_la_livraison_des_articles
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm3'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        let typeOffer = new TypeOffer();
        typeOffer.name = form.name;
        typeOffer.slug = form.slug;
        typeOffer.type = form.type;
        typeOffer.param0 = form1.param0;
        typeOffer.description = formd.description;
        //console.log("Nouveau type d'offre à enregistrer avec x_montant_reduit_sur_la_livraison_des_articles...");
        //console.log(typeOffer);
        this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été ajouté avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
          //console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.x_article_achete_y_article_offert || this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
      if(this.typeOfferForm.controls.typeOfferForm4.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_article_achete_y_article_offert
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm4'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        let typeOffer = new TypeOffer();
        typeOffer.name = form.name;
        typeOffer.slug = form.slug;
        typeOffer.type = form.type;
        typeOffer.param0 = form1.param0;
        typeOffer.param1 = form1.param1;
        typeOffer.description = formd.description;
       // console.log("Nouveau type d'offre à enregistrer avec x_article_achete_y_article_offert...");
       // console.log(typeOffer);
        this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été ajouté avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction || this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
      if(this.typeOfferForm.controls.typeOfferForm5.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_produit_achete_n_ieme_a_y_pourcent_de_reduction
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm5'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        let typeOffer = new TypeOffer();
        typeOffer.name = form.name;
        typeOffer.slug = form.slug;
        typeOffer.type = form.type;
        typeOffer.param0 = form1.param0;
        typeOffer.param1 = form1.param1;
        typeOffer.param2 = form1.param2;
        typeOffer.description = formd.description;
        //console.log("Nouveau type d'offre à enregistrer avec x_produit_achete_n_ieme_a_y_pourcent_de_reduction...");
        //console.log(typeOffer);
        this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été ajouté avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.frais_de_deplacement_gratuite){
            // frais de déplacement gratuit
            let typeOffer = new TypeOffer();
            let form = this.typeOfferForm.controls['typeOfferForm0'].value;
            let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
            typeOffer.name = form.name;
            typeOffer.slug = form.slug;
            typeOffer.type = form.type;
            typeOffer.description = formd.description;
           // console.log("Nouveau type d\'offre à enregistrer avec frais de déplacement gratuite...");
           // console.log(typeOffer);
            this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Le type d\'offre a été ajouté avec succés.',
                showConfirmButton: false,
                timer: 1500
              });
              this.close();
              this.loadOfferTypes();
              this.reloadComponent();
            }, error => {
              //console.log(error);
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 2500
              });
            });
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid &&
             this.typeOfferForm.controls.typeOfferForm6.valid &&
             this.reduction_de_x_montant_sur_les_frais_de_deplacement){
        if(this.typeOfferForm.controls.typeOfferForm3.invalid){
          this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
          this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
          this.typeOfferForm.controls.typeOfferForm3.markAllAsTouched();
          this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
          this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
          this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
          return;
        }else{
          // reduction_de_x_montant_sur_les_frais_de_deplacement
          let form = this.typeOfferForm.controls['typeOfferForm0'].value;
          let form1 = this.typeOfferForm.controls['typeOfferForm3'].value;
          let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
          let typeOffer = new TypeOffer();
          typeOffer.name = form.name;
          typeOffer.slug = form.slug;
          typeOffer.type = form.type;
          typeOffer.param0 = form1.param0;
          typeOffer.description = formd.description;
          //console.log("Nouveau type d'offre à enregistrer avec reduction_de_x_montant_sur_les_frais_de_deplacement...");
          //console.log(typeOffer);
          this.typeOfferService.saveTypeOffer(typeOffer).subscribe(rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Le type d\'offre a été ajouté avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.close();
            this.loadOfferTypes();
            this.reloadComponent();
          }, error => {
           // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            });
          });
        }
    }

    // this.typeOfferForm.controls.typeOfferForm1.invalid
    // console.log(this.typeOfferForm.value)
  }

  isoequalstoname = false;
  verifyPromotionName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  // get f1() { return this.editTypeOfferForm.controls; }

  // editTypeOfferForm = this.fb.group({
  //   name: new FormControl('', [Validation.nameValidator_updated("Le nom",3,100)]),
  //   description: new FormControl('', [Validation.requiredValidator("La description")]),
  // });

  onEditTypeOffer(id: any) {
    this.typeOfferService.getIdTypeOffer(id).subscribe(rs => {
      this.currentoffertype = rs;
      //console.log("Type d'offre à modifier");
      //console.log(this.currentoffertype);
      this.getSelectedSlug(this.currentoffertype?.slug);
      this.typeOfferForm = this.fb.group({
        typeOfferForm0: this.fb.group({
          name : new FormControl(this.currentoffertype.name , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
          slug : new FormControl (this.currentoffertype.slug , [Validators.required]),
          type : new FormControl (this.currentoffertype.type , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
        }),
        // x-pourcent-de-reduction
        typeOfferForm1: this.fb.group({
          param0 : new FormControl(this.currentoffertype.param0 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
        }),
        // Livraison-gratuite-x-montant
        typeOfferForm2: this.fb.group({
          param0 : new FormControl(this.currentoffertype.param0 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
        }),
        // x-montant-reduit-sur-la-livraison-des-articles
        typeOfferForm3: this.fb.group({
          param0 : new FormControl(this.currentoffertype.param0 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
        }),
        // x-article-achete-y-article-offert
        typeOfferForm4: this.fb.group({
          param0 : new FormControl(this.currentoffertype.param0 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
          param1 : new FormControl(this.currentoffertype.param1 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
        }),
        // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
        typeOfferForm5: this.fb.group({
          param0 : new FormControl(this.currentoffertype.param0 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
          param1 : new FormControl(this.currentoffertype.param1 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
          param2 : new FormControl(this.currentoffertype.param2 , [Validation.nameValidator_updated("Le nom du paramètre",3,100)]),
        }),

        typeOfferForm6: this.fb.group({
          description : new FormControl(this.currentoffertype.description, [Validators.required, Validators.minLength(10)]),
        }),
      });
    });
  }

  oneditTypeOfferFormSubmit(){
   // console.log("Type d'offre à modifier...")
   // console.log(this.currentoffertype);
    if(this.typeOfferForm.controls.typeOfferForm0.invalid){
      this.typeOfferForm.controls.typeOfferForm0.markAllAsTouched();
      this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
      this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
      return;
    }
    if(this.typeOfferForm.controls.typeOfferForm0.valid && this.livraison_gratuite || this.frais_de_deplacement_gratuite){
      // livraison gratuite
      let form = this.typeOfferForm.controls['typeOfferForm0'].value;
      let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
      this.currentoffertype.name = form.name;
      this.currentoffertype.slug = form.slug;
      this.currentoffertype.type = form.type;
      this.currentoffertype.description = formd.description;
      //console.log("Nouveau type d\'offre à modifier avec livraison gratuite...");
      //console.log(this.currentoffertype);
      this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Le type d\'offre a été modifié avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadOfferTypes();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 2500
        });
      });
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid && this.x_pourcent_de_reduction_produit || this.x_pourcent_de_reduction_service){
      if(this.typeOfferForm.controls.typeOfferForm1.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x-pourcent-de-reduction
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm1'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        this.currentoffertype.name = form.name;
        this.currentoffertype.slug = form.slug;
        this.currentoffertype.type = form.type;
        this.currentoffertype.param0 = form1.param0;
        this.currentoffertype.description = formd.description;
        //console.log("Modification avec x-pourcent-de-reduction...");
        this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été modifié avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
          //console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }

    }else if(this.typeOfferForm.controls.typeOfferForm0.valid && this.livraison_gratuite_x_montant){
      if(this.typeOfferForm.controls.typeOfferForm2.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // livraison_gratuite_x_montant
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm2'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        this.currentoffertype.name = form.name;
        this.currentoffertype.slug = form.slug;
        this.currentoffertype.type = form.type;
        this.currentoffertype.param0 = form1.param0;
        this.currentoffertype.description = formd.description;
       // console.log("Modification avec livraison_gratuite_x_montant...");
       // console.log(this.currentoffertype);
        this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été modifié avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid && this.x_montant_reduit_sur_la_livraison_des_articles || this.reduction_de_x_montant_sur_les_frais_de_deplacement){
      if(this.typeOfferForm.controls.typeOfferForm3.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_montant_reduit_sur_la_livraison_des_articles
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm3'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        this.currentoffertype.name = form.name;
        this.currentoffertype.slug = form.slug;
        this.currentoffertype.type = form.type;
        this.currentoffertype.param0 = form1.param0;
        this.currentoffertype.description = formd.description;
       // console.log("Modification avec x_montant_reduit_sur_la_livraison_des_articles...");
       // console.log(this.currentoffertype);
        this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été modifié avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid && this.x_article_achete_y_article_offert || this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
      if(this.typeOfferForm.controls.typeOfferForm4.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm5.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_article_achete_y_article_offert
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm4'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        this.currentoffertype.name = form.name;
        this.currentoffertype.slug = form.slug;
        this.currentoffertype.type = form.type;
        this.currentoffertype.param0 = form1.param0;
        this.currentoffertype.param1 = form1.param1;
        this.currentoffertype.description = formd.description;
       // console.log("NoModification avec x_article_achete_y_article_offert...");
       // console.log(this.currentoffertype);
        this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été modiifié avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }else if(this.typeOfferForm.controls.typeOfferForm0.valid && this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction || this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
      if(this.typeOfferForm.controls.typeOfferForm5.invalid){
        this.typeOfferForm.controls.typeOfferForm1.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm2.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm3.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm4.markAsUntouched();
        this.typeOfferForm.controls.typeOfferForm5.markAllAsTouched();
        this.typeOfferForm.controls.typeOfferForm6.markAsUntouched();
        return;
      }else{
        // x_produit_achete_n_ieme_a_y_pourcent_de_reduction
        let form = this.typeOfferForm.controls['typeOfferForm0'].value;
        let form1 = this.typeOfferForm.controls['typeOfferForm5'].value;
        let formd = this.typeOfferForm.controls['typeOfferForm6'].value;
        this.currentoffertype.name = form.name;
        this.currentoffertype.slug = form.slug;
        this.currentoffertype.type = form.type;
        this.currentoffertype.param0 = form1.param0;
        this.currentoffertype.param1 = form1.param1;
        this.currentoffertype.param2 = form1.param2;
        this.currentoffertype.description = formd.description;
        //console.log("NModification avec x_produit_achete_n_ieme_a_y_pourcent_de_reduction...");
        //console.log(this.currentoffertype);
        this.typeOfferService.updateTypeOffer(this.currentoffertype).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le type d\'offre a été modifié avec succés.',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadOfferTypes();
          this.reloadComponent();
        }, error => {
          //console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    }
  }

  loadTypeOffers = () => {
    this.typeOfferService.getTypeOffers().subscribe(data => {
      this.offertypes = data;
    }, (err) => {
      // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
  }

  searchFilter($event: KeyboardEvent) {
    // console.log(this.search);
    this.typeOfferService.getTypeOffers()
      .subscribe(data => {
        this.offertypes = data;
        this.offertypes = this.offertypes.filter(value =>
        value.name.toUpperCase().includes(this.search.toUpperCase())
        || value.description?.includes(this.search.toUpperCase()));
    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  delete(id: number) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ce type d\'offre ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.typeOfferService.deleteTypeOffer(id).subscribe(rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Le type d\'offre a été supprimé avec succés."',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadOfferTypes();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Impossible de supprimer ce type d\'offre car elle est associée a au moins une promotion',
              showConfirmButton: false,
              timer: 2500
            });
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        });
      }
    });
  }


  sort1() {
    if(this.sorted == false) {
      // @ts-ignore
      this.offertypes.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted = true;
    } else {
      // @ts-ignore
      this.offertypes.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted = false;
    }
  }

  sort2() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.offertypes.sort((a, b) => a?.slug > b?.slug ? 1 : a?.slug < b?.slug ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.offertypes.sort((a, b) => a?.slug < b?.slug ? 1 : a?.slug > b?.slug ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort3() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.offertypes.sort((a, b) => a.description > b.description ? 1 : a.description < b.description ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.offertypes.sort((a, b) => a.description < b.description ? 1 : a.description > b.description ? -1 : 0)
      this.sorted2 = false;
    }
  }

}
